import { forwardRef } from 'react'
import { cn } from '../utils/cn.ts'

export interface PaymentDividerProps {
  variant?: 'card' | 'alternative'
  className?: string
}

const variantText: Record<NonNullable<PaymentDividerProps['variant']>, string> = {
  card: 'or pay with card',
  alternative: 'or pay another way',
}

export const PaymentDivider = forwardRef<HTMLDivElement, PaymentDividerProps>(
  function PaymentDivider({ variant = 'card', className }, ref) {
    return (
      <div ref={ref} className={cn('payment-divider', className)}>
        <div className="payment-divider-line" />
        <span className="payment-divider-text">{variantText[variant]}</span>
        <div className="payment-divider-line" />
      </div>
    )
  },
)
